/** Pie de página común a todas las pantallas (especificación §2.2). */
export function PiePagina() {
  return <footer className="py-3 text-center text-xs text-slate-400">© 2026 Alter Realitas</footer>;
}
